import React, { useState, useEffect, createRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BsHourglassSplit } from "react-icons/bs";
import { Splide, SplideSlide } from "@splidejs/react-splide";

import { seasonsService } from "../../services/Seasons/SeasonsService";
import { appStore } from "../../stores/appStore";
import CountDownTimer from "../CountDownTimer/CountDownTimer";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import { StyledGameWeek, StyledGameWeekLive, StyledGameWeekTimer } from "./GameWeekStyledComponent";

const GameWeeks = () => {

  const { t } = useTranslation("General");
  // based on status gameweek showing active
  const WeekStatus = {
    Live: "LIVE",
    BET_WEEK: "BET_WEEK",
    UP_COMING: "UP_COMING",
    COMPLETED: "COMPLETED",
  };

  // based on Location Path component navigating
  const ActiveRoute = {
    Live: "/matches/live",
    GameTable: "/matches/gametable",
  };

  const [weeksList, setWeeksList] = useState([]);
  const [lastweek, setLastWeek] = useState(true);
  const [activeRoute, setActiveRoute] = useState("/matches/gametable");
  const splideRef = createRef();
  const navigate = useNavigate();
  let location = useLocation();

  // getting and setting value in appStore
  const {
    liveWeekNumber,
    currentLeague,
    currentSeason,
    setSelectedBetWeek,
    selectedBetWeek,
  } = appStore((state) => ({
    liveWeekNumber: state.liveWeekNumber,
    countDownTimer: state.countDownTimer,
    currentLeague: state.currentLeague,
    currentSeason: state.currentSeason,
    setSelectedBetWeek: state.setSelectedBetWeek,
    selectedBetWeek: state.selectedBetWeek,
  }));

  /* fetching game weeks details from season backend API */
  useEffect(() => {
    const getWeeksListDetails = async () => {
      const response = await seasonsService.getWeeksList(
        currentLeague.leagueId,
        currentSeason
      );
      let data = response.data;

      // if (data.length > 0) {
      const weeksData = data.length > 0 ? data[0].weeks : [];
      let windowWidth = window.innerWidth;
      if (windowWidth <= 580) {
        if (liveWeekNumber <= 0) {
          const first = weeksData.slice(liveWeekNumber, liveWeekNumber + 3);
          setWeeksList(first);
        } else if (liveWeekNumber > 0) {
          const first3 = weeksData.slice(
            liveWeekNumber - 1,
            liveWeekNumber + 2
          );
          setWeeksList(first3);
        } else if (liveWeekNumber < 2) {
          const fst = weeksData.slice(liveWeekNumber, liveWeekNumber + 3);
          setWeeksList(fst);
        }
      } else {
        setWeeksList(weeksData);
      }
      let lastWeekLive = weeksData.find((week) => {
        return week.weekId === "38" && week.weekStatus === WeekStatus.Live;
      });
      if (lastWeekLive) {
        navigate("/matches/live");
      }
      // }
      if (liveWeekNumber === 0) {
        navigate("/matches/gametable");
      }
    };
    getWeeksListDetails();

  }, [currentLeague, currentSeason, liveWeekNumber]);

  useEffect(() => {
    if (splideRef.current) {
      splideRef.current.go(liveWeekNumber - 1);
    }
  }, [splideRef, liveWeekNumber]);

  // 1st rendering BET_WEEk selected
  useEffect(() => {
    setSelectedBetWeek(1);
  }, []);

  /* By cliking game weeks displaying matchtable and live table components */
  const onClickGameWeeks = (weekDetails) => {
    if (weekDetails.weekStatus === WeekStatus.BET_WEEK) {
      navigate("/matches/gametable");
      setSelectedBetWeek(1);
    } else if (weekDetails.weekStatus === WeekStatus.Live) {
      navigate("/matches/live");
    } else if (weekDetails.weekStatus === WeekStatus.UP_COMING) {
      navigate("/matches/gametable");
      setSelectedBetWeek(2);
    } else {
      setLastWeek(false);
      // setSelectedBetWeek(0);
    }
  };

  // depend upon location pathname weekstatus changed
  useEffect(() => {
    if (location.pathname === "/matches/gametable") {
      setActiveRoute(ActiveRoute.GameTable);
    } else if (location.pathname === "/matches/live") {
      setActiveRoute(ActiveRoute.Live);
    }
  }, [location]);

  const onDragging = (evt) => {
    const splidListElement = document.getElementsByClassName("splide__list")[0];
    // it will always be available and [0] will not be undefined as this dragging event fired only when the splide is available
    const xPos = splidListElement.getBoundingClientRect().x;

    let value = 0;
    if (xPos < -400) {
      value = -400;
    }
    if (xPos > 150) {
      value = 150;
    }
    if (value) {
      splidListElement.style.transform = `translateX(${value}px)`;
    }
  };
  return (
    <React.Fragment>
      <div className="w-100 mt-1 px-3">
        {weeksList.length > 0 && (
          <Splide
            onDragging={onDragging}
            ref={splideRef}
            options={{
              type: "false",
              omitEnd: true,
              autoWidth: false,
              pagination: false,
              arrows: false,
              perPage: 3,
              drag: false,
              gap: "0.5rem",
              speed: 1000,
              trimSpace: true,
              breakpoints: {
                320: {
                  //upto 320
                  perPage: 1.8,
                  drag: "free",
                  omitEnd: true,
                  snap: true,
                },
                374: {
                  perPage: 2.1,
                  drag: "free",
                  snap: true,
                },
                420: {
                  //upto 420
                  perPage: 2.2,
                  drag: "free",
                  omitEnd: true,
                  snap: true,
                },
                425: {
                  //upto 425
                  perPage: 2.5,
                  drag: "free",
                  omitEnd: true,
                  snap: true,
                },
                580: {
                  //upto 580
                  perPage: 2.2,
                  drag: "free",
                  omitEnd: true,
                  snap: true,
                },
              },
            }}
          >
            {weeksList.map((week) => (
              <SplideSlide key={week.weekId}>
                <div className="pb-1 week-height">
                  <div>
                    <div className="flex-fill d-grid text-decoration-none">
                      <StyledGameWeek selected={
                        (activeRoute === ActiveRoute.Live &&
                          week.weekStatus === WeekStatus.Live) ||
                        (activeRoute === ActiveRoute.GameTable &&
                          week.weekStatus === WeekStatus.BET_WEEK &&
                          liveWeekNumber + selectedBetWeek == week.weekId) ||
                        (activeRoute === ActiveRoute.GameTable &&
                          week.weekStatus === WeekStatus.UP_COMING &&
                          liveWeekNumber + selectedBetWeek == week.weekId) ||
                        (week.weekStatus === WeekStatus.COMPLETED &&
                          liveWeekNumber + selectedBetWeek == week.weekId &&
                          lastweek === true)
                      }
                        className={
                          (activeRoute === ActiveRoute.Live &&
                            week.weekStatus === WeekStatus.Live) ||
                            (activeRoute === ActiveRoute.GameTable &&
                              week.weekStatus === WeekStatus.BET_WEEK &&
                              liveWeekNumber + selectedBetWeek == week.weekId) ||
                            (activeRoute === ActiveRoute.GameTable &&
                              week.weekStatus === WeekStatus.UP_COMING &&
                              liveWeekNumber + selectedBetWeek == week.weekId) ||
                            (week.weekStatus === WeekStatus.COMPLETED &&
                              liveWeekNumber + selectedBetWeek == week.weekId &&
                              lastweek === true)
                            ? "btn btn-sm border-secondary text-secondary text-start fw-bold d-flex justify-content-between align-items-center gameweekblock"
                            : week.weekStatus === WeekStatus.COMPLETED
                              ? "btn btn-sm border text-black text-start d-flex justify-content-between align-items-center gameweekblock cursor-default"
                              : "btn btn-sm border text-black text-start d-flex justify-content-between align-items-center gameweekblock"
                        }
                        onClick={() => onClickGameWeeks(week)}
                      >
                        <div>{t("Gameweek")} {t(`${week.weekId}`)}</div>
                        <div className="liveTime">
                          {week.weekStatus === WeekStatus.Live && (
                            <StyledGameWeekLive className="rounded text-black p-1 bg-warning d-flex align-items-center text-center live-text">
                              <b className="px-1">{t("LIVE")}</b>
                            </StyledGameWeekLive>
                          )}
                          {week.weekStatus === WeekStatus.BET_WEEK && (
                            <StyledGameWeekTimer selected={week.weekStatus === WeekStatus.BET_WEEK} className="bg-secondary text-white rounded d-flex align-items-center px-1 text-center betweek-counter">
                              <BsHourglassSplit
                                className="text-start rotate"
                                size="15px"
                              />
                              <CountDownTimer className="text-end" />
                            </StyledGameWeekTimer>
                          )}
                        </div>
                      </StyledGameWeek>
                    </div>
                  </div>
                </div>
              </SplideSlide>
            ))}
          </Splide>
        )}
      </div>
    </React.Fragment>
  );
};
export default GameWeeks;
